module.exports = __webpack_public_path__ + "img/1489853504.c6803030.jpg";